/**
 * Constants for dashboard filter operations
 */
export const FILTER_CONSTANTS = {
  /**
   * ID for the special "Shared & Unassigned" filter that shows tasks that:
   * - Have no assignee
   * - Have a deadline
   * - Belong to a shared project
   */
  SHARED_UNASSIGNED: 'shared-unassigned'
};